import React, { Component } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from "@material-ui/core";
import "./AiTextDialog.scss";
import Button from "../VMButton";
import i18n from "@/i18n";

class AiTextDialog extends Component {
    render() {
        const { open, header, onCancel, onClose, onOk, onChange } = this.props;
        return (
            <div>
                <Dialog
                    open={open}
                    aria-labelledby="new-template-title"
                    onClose={onClose}
                    aria-describedby="new-template-desc"
                >
                    <div style={{ minWidth: "400px" }}>
                        <DialogTitle
                            lang={this.props.value}
                            id="new-template-title"
                        >
                            {header}sfjsdfkj
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                // fullWidth={true}
                                lang={this.props.value}
                                onChange={onChange}
                                multiline
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                style={{ marginRight: "10px" }}
                                color="default"
                                width="80px"
                                height="30px"
                                onClick={onCancel}
                            >
                                닫기
                            </Button>
                            <Button
                                color="primary"
                                width="80px"
                                height="30px"
                                onClick={onOk}
                            >
                                {i18n.t("global.confirm")}
                            </Button>
                        </DialogActions>
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default AiTextDialog;
